<template>
  <InputTaoSir :_value="_value" :propertie="propertie" :tipRule="tipRule" @change="change"></InputTaoSir>
</template>

<script>
import storeMixins from '../store-mixins';
import InputTaoSir from './InputTaoSir.vue';
export default {
  mixins: [storeMixins],
  props: ['props', 'tipRule', 'value'],
  components: {
    InputTaoSir,
  },
  data() {
    return {
      formats: [],
    };
  },
  watch: {},
  computed: {
    key() {
      return this.props.name;
    },
    propertie() {
      return this.props.dataSource?.properties[0] || {};
    },
    _value() {
      return this.alibabaForm[this.key] || '';
    },
    isCatProp() {
      return this.props.parentName === 'catProp';
    },
  },
  methods: {
    change(formats) {
      const newFormFields = {};
      if (formats?.length) {
        const concatTypes = ['input', 'operator', 'unit'];
        const isEveryValue = formats.every(item => item.text);
        let value = '';
        // 度量衡组合完整才更新
        if (isEveryValue) {
          value = formats
            .filter(item => concatTypes.includes(item.type))
            .map(item => item.text)
            .join('');
        }
        newFormFields[this.key] = value;
        newFormFields[`${this.key}_formats`] = formats;
        this.updateAlibabaForm(newFormFields);
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.taoSirProperty-content {
  font-size: 12px;
}
</style>